<ftr-page>
  @if (errorMessage) {
    <article>
      <ftr-notification [type]="notificationType.Error">
        <div class="whitespace-pre-line">{{ errorMessage }}</div>
      </ftr-notification>
    </article>
  }

  <ng-content *ifGlobalAdmin>
    @if (addUserRouterLink(); as addUserRouterLink) {
      <article>
        <div>
          @if (isForbiddenCourtSystemForFtrStaff()) {
            <ftr-notification [type]="notificationType.Error">
              <strong>DO NOT ADD YOURSELF TO THIS COURT SYSTEM!</strong>
              <br />
              You're a <strong>Global Admin</strong> but <ng-template *ngTemplateOutlet="courtSystemName" /> has
              <a
                href="https://www.notion.so/ftrlabs/Customer-we-do-not-support-10cb5c7fbf27809590f2ed004dbf0b52"
                target="_blank"
                >forbidden FTR staff from accessing it</a
              >.
            </ftr-notification>
          } @else {
            <ftr-notification [type]="notificationType.Info">
              You're a <strong>Global Admin</strong>.
              <a [routerLink]="addUserRouterLink" [queryParams]="addUserQueryParams()">Click here</a> to add yourself to
              <ng-template *ngTemplateOutlet="courtSystemName" />. Once added, you'll be redirected to your intended
              page.
            </ftr-notification>
          }
        </div>
      </article>

      <ng-template #courtSystemName>
        @if (courtSystem(); as courtSystem) {
          <strong>{{ courtSystem.name }}</strong>
        } @else {
          this court system
        }
      </ng-template>
    }
  </ng-content>
</ftr-page>
